export const DamageTypeLabel = {
	NONE: "Nenhum",
	SCRATCH: "Riscado",
	CHIP: "Pique",
	DENT: "Amassado",
	BROKEN: "Quebrado",
	MISSING: "Faltando",
	CRACK: "Trincado",
	STAIN: "Manchado",
	OTHER: "Outro",
} as const;

export type DamageKeyType = keyof typeof DamageTypeLabel;
